import Vue from 'vue'
import Modal from './index'

export default Vue.extend({
  template: '<component :is="activeModal" v-bind="options" v-click-outside="outside"></component>',
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  data () {
    return {
      options: {},
      activeModal: null
    }
  },
  watch: {
    activeModal (val, oldVal) {
      if (val === oldVal) return
      if (val !== null && this.$modal.options.onOpen) {
        this.$modal.options.onOpen(this.activeModal)
      } else if (this.$modal.options.onClose) {
        this.$modal.options.onClose()
      }
    }
  },
  beforeMount () {
    Modal.event.$on('open-modal', (name, options) => {
      if (this.containers[name] !== this.name) return
      this.options = options
      this.activeModal = name
    })

    Modal.event.$on('close-modal', () => {
      this.activeModal = null
    })
  },
  methods: {
    outside () {
      if (this.options.autoclose !== false) this.activeModal = null
    }
  },
  directives: {
    'click-outside': {
      bind: function (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
          if (compName) { warn += `Found in component '${compName}'` }

          console.warn(warn)
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler

        // add Event Listeners
        document.addEventListener('click', handler)
      },
      unbind: function (el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/plugins/modal/modal-view.js